module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer004",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "fl-fl-roman"
  }, [_c('b', [_vm._v("Winnie Griggs ")]), _vm._v("is the multipublished, award-winning author of historical (and occasionally contemporary) romances that focus on small towns, big hearts and amazing grace. She is also a list maker and a lover of dragonflies, and holds an advanced degree in the art of procrastination. Winnie loves to hear from readers—you can connect with her on Facebook at "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/WinnieGriggs.Author/",
      "target": "_blank"
    }
  }, [_vm._v("Facebook.com/winniegriggs.author")]), _vm._v(" or email her at "), _c('a', {
    attrs: {
      "href": "mailto:winnie%40winniegriggs.com?subject=Contact%20Winnie%20Griggs"
    }
  }, [_vm._v("winnie@winniegriggs.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center-bold"
  }, [_c('b', [_vm._v("Books by Winnie Griggs")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-series"
  }, [_vm._v("Love Inspired Historical")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Texas Grooms")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Handpicked Husband")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("The Bride Next Door")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("A Family for Christmas")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Lone Star Heiress")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Her Holiday Family")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Second Chance Hero")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("The Holiday Courtship")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Texas Cinderella")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("A Tailor-Made Husband")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Once Upon a Texas Christmas")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("Visit the Author Profile page"), _c('br'), _vm._v("at ")]), _c('a', {
    attrs: {
      "href": "http://www.LoveInspired.com",
      "target": "_blank"
    }
  }, [_vm._v("LoveInspired.com")]), _c('span', {
    staticClass: "hyperlink"
  }, [_vm._v(" for more titles")]), _c('span', {
    staticClass: "roman"
  }, [_vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c87a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About_the_Author.vue
// module id = 69
// module chunks = 0